import { Component, OnInit } from '@angular/core';
import { MbDialogRef, MbDialogFooter, MbDialogBody, MbIcon, MbButton } from '@am/moebius';

@Component({
  selector: 'app-rate-unavailable',
  standalone: true,
  imports: [MbDialogFooter, MbDialogBody, MbIcon, MbButton],
  templateUrl: './rate-unavailable.component.html',
  styleUrls: ['./rate-unavailable.component.scss'],
})
export class RateUnavailableComponent implements OnInit {
  constructor(public dialogRef: MbDialogRef<RateUnavailableComponent>) {}

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public refreshPage(): void {
    window.location.reload();
  }

  ngOnInit(): void {}
}
